export default "__VITE_ASSET__CkYs7Phy__"